export const CONNECTOR_CATALOG_EXCLUDED_NAMES = new Set([
  // Developer infrastructure.
  '0codekit',
  'adafruit io',
  'azure monitor activity log',
  'backendless',
  'clickhouse',
  'code interpreter',
  'configcat',
  'context.dev',
  'databricks',
  'elasticsearch',
  'influxdb cloud',
  'kibana',
  'pagerduty',
  'seqera',
  'snowflake',
  'snowflake basic',
  'wakatime',
  'weights & biases',
  // Finance, trading, and payments.
  'alpaca',
  'alpha vantage',
  'beaconcha.in',
  'benzinga',
  'bitquery',
  'btcpay server',
  'coingecko',
  'coinmarketcal',
  'coinmarketcap',
  'coinranking',
  'eodhd apis',
  'finage',
  'finnhub',
  'finviz',
  'hitpay',
  'lemon squeezy',
  'marketstack',
  'maxio',
  'nasdaq',
  'opensea',
  'payhere',
  'pocketsmith',
  'polygon.io',
  'polymarket us',
  'proabono',
  'recurly',
  'sec edgar',
  'square',
  'stripe',
  'token metrics',
  'twelve data',
  // Unrelated specialist services.
  '7shifts',
  'acculynx',
  'agencyzoom',
  'apaleo',
  'blackbaud',
  'bookingmood',
  'college football data',
  'commcare',
  'fleetio',
  'gorilladesk',
  'headout',
  'ignav flights',
  'instacart',
  'jobnimbus',
  'lodgify',
  'mindbody',
  'optimoroute',
  'repairshopr',
  'seat geek',
  'servicem8',
  'ticketmaster',
  'tripadvisor',
  'tripadvisor content api',
  'uplisting',
  'workiz',
  // Personal or academic services.
  'beeminder',
  'cats',
  'exist',
  'habitica',
  'openalex',
  'semantic scholar',
  'twitch',
  // Approved AI, research, utility, and developer-only removals.
  'cody',
  'all images ai',
  'alttext.ai',
  'alttextlab',
  'deepimage',
  'gamma',
  'magicslides',
  'magic hour',
  'imagerouter',
  'heygen',
  'joggai',
  'docsbot ai',
  'airparser',
  'algodocs',
  'docsumo',
  'manus',
  'neuronwriter',
  'company url finder',
  'cloudconvert',
  'activemerge',
  'docparser',
  'encodian',
  'transloadit',
  'drop to cdn',
  'upload to url',
  'imgbb',
  'gofile',
  'agent mail',
  'authyo',
  'csvbox',
  'cronfree time scheduler',
  'daily',
  'mailslurp',
  'gender api',
  'genderize',
  'ip2location',
  'bulk email checker',
  'mailboxlayer',
  'invalid bounce',
  'google super',
  'fathom',
  'brandfetch',
  'logo.dev',
]);

export function isConnectorCatalogNameExcluded(name: string): boolean {
  return CONNECTOR_CATALOG_EXCLUDED_NAMES.has(
    name.trim().replace(/\s+/g, ' ').toLowerCase()
  );
}

// Approved removal of redundant creation services, developer infrastructure,
// and narrow connectors. Keep this list explicit so catalog sync and reads
// cannot reintroduce an entry under a still-allowed category.
export const CONNECTOR_CATALOG_APPROVED_REMOVAL_SLUGS = new Set([
  // Image creation and processing already available in the workspace.
  'abyssale',
  'adrapid',
  'apiflash',
  'bannerbear',
  'bannerbite',
  'chartly',
  'claid_ai',
  'dynamic_mockups',
  'dynapictures',
  'html_to_image',
  'htmlcss_to_image',
  'imagior',
  'imejis_io',
  'imgix',
  'kraken_io',
  'layerre',
  'okzest',
  'photoroom',
  'picnie',
  'placid',
  'remove_bg',
  'renderform',
  'screenshot_api',
  'shortpixel',
  'slazzer',
  'supportivekoala',
  'templated',
  'tinypng',
  'twittershots',
  // Document and PDF generation already available in the workspace.
  'api2pdf',
  'carbone',
  'cloudlayer',
  'compdf',
  'conversion_tools',
  'convertapi',
  'craftmypdf',
  'docmosis',
  'docugenerate',
  'documentero',
  'documint',
  'docupilot',
  'docupotion',
  'eledo',
  'filetopdf',
  'i_love_pdf',
  'pdf_blocks',
  'pdf_munk',
  'pdf_api_io',
  'pdf_co',
  'pdf4me',
  'pdfgen',
  'pdfless',
  'pdfmonkey',
  // Media rendering already available in the workspace.
  'creatomate',
  'eranol',
  'shotstack',
  'video_db',
  // Programmable communications infrastructure, not end-user destinations.
  '_2chat',
  'android_texter',
  'blooio',
  'kapso',
  'mocean',
  'msg91',
  'onesignal_rest_api',
  'onesignal_user_auth',
  'plivo',
  'push_by_techulus',
  'push_alert',
  'pushinator',
  'saperly',
  'sendbird',
  'seven_io',
  'telnyx',
  'teltel',
  'unipile',
  'waboxapp',
  'webpushr',
  // Narrow utilities or connectors with too little useful coverage.
  'boloforms',
  'callerapi',
  'draftable',
  'echtpost',
  'flexisign',
  'iplocate',
  'ip_registry',
  'leadoku',
  'livesession',
  'onepage',
  'plasmic',
  'realphonevalidation',
  'sympla',
  'timecamp',
  'timelink',
  'u301',
  // Approved AI and research overlap.
  'cody',
  'all_images_ai',
  'alttext_ai',
  'alt_text_lab',
  'deepimage',
  'gamma',
  'magicslides',
  'magic_hour',
  'imagerouter',
  'heygen',
  'jogg_ai',
  'docsbot_ai',
  'airparser',
  'algodocs',
  'docsumo',
  'manus',
  'neuronwriter',
  'company_url_finder',
  'brandfetch',
  'logo_dev',
  // Approved file and document utilities.
  'cloudconvert',
  'active_merge',
  'docparser',
  'encodian',
  'transloadit',
  'drop_to_cdn',
  'upload_to_url',
  'imgbb',
  'gofile',
  // Approved developer and narrow lookups.
  'agent_mail',
  'authyo',
  'csvbox',
  'cronfree_time_scheduler',
  'daily',
  'mailslurp',
  'gender_api',
  'genderize',
  'ip2location',
  'bulk_email_checker',
  'mailboxlayer',
  'invalid_bounce',
  // Approved Soon entries.
  'googlesuper',
  'fathom',
]);

export function isConnectorCatalogExcluded(card: {
  toolkitSlug: string;
  label: string;
}): boolean {
  return (
    CONNECTOR_CATALOG_APPROVED_REMOVAL_SLUGS.has(card.toolkitSlug) ||
    isConnectorCatalogNameExcluded(card.label)
  );
}
